import { render, staticRenderFns } from "./QcqDialog.vue?vue&type=template&id=0d882576&scoped=true&lang=pug&"
import script from "./QcqDialog.vue?vue&type=script&lang=ts&"
export * from "./QcqDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d882576",
  null
  
)

export default component.exports